import { PrintInfo } from "burde";
import * as api from "util/api";

export const getPublishedCalendarThemes = async (): Promise<
    Array<PrintInfo>
> => {
    try {
        const { success, data } = await api.json.get(
            "api/calendar/getpublishedcalendarthemes",
        );

        if (!success) {
            return [];
        }

        return data as Array<PrintInfo>;
    } catch {
        return [];
    }
};

export const getCalendarThemes = async (): Promise<Array<PrintInfo>> => {
    try {
        const { success, data } = await api.json.get(
            "api/calendar/getcalendarthemes",
        );

        if (!success) {
            return [];
        }

        return data as Array<PrintInfo>;
    } catch {
        return [];
    }
};

export const publishTheme = async (id: number) =>
    await api.json.post("api/calendar/publishtheme", { id });

export const unpublishTheme = async (id: number) =>
    await api.json.post("api/calendar/unpublishtheme", { id });
